import React from "react";
import "./Home.css";
import { SubmissionButton } from "../SumbissionButton";
import { Profile } from "../Profile";

export const PhDForumCalls = () => {
  const submitButton = {
    title: "Presentation for the PhD Forum",
    url: "https://smartcomp2025phdforum.edas.info/",
  };

  const profilesPhD = [
    {
      title: "Prof",
      firstName: "Cormac",
      surname: "Sreenan",
      university: "University College Cork",
      bio: "https://www.ucc.ie/en/misl/people/csreenan/",
      image: "./images/profiles/Cormac.png",
      linkedin:
        "https://www.linkedin.com/in/cormac-sreenan-593b9520/?originalSubdomain=ie",
      //twitter: "https://x.com/sreenan_cj",
      email: "cormac.sreenan@ucc.ie",
    },
    {
      title: "Prof",
      firstName: "Stephan",
      surname: "Sigg",
      university: "Aalto University, Finland",
      bio: "https://www.aalto.fi/en/people/stephan-sigg",
      image: "./images/profiles/stephan.jpg",
      linkedin: null,
      email: "stephan.sigg@aalto.fi",
    },
  ];

  return (
    <div className="page-layout">
      <div className="text-layout">
        <SubmissionButton props={submitButton} className="submit-button" />
        <h2>Call for Contributions: SmartComp 2025 PhD Forum</h2>
        <p>
          The Ph.D. Forum at SmartComp 2025 provides an opportunity for Ph.D.
          students to present their work in progress to the scientific community
          and obtain individual feedback from leading researchers in the field.
          This forum is intended to provide doctoral students with a platform to
          interact with established researchers from both academia and industry
          and get useful guidance on the broader impacts of their research.
        </p>
        <p>
          The Forum will be structured as a poster presentation session and
          discussions. The poster presentations will be interleaved with
          speeches by leading researchers, who will provide their own
          perspectives on research in the field, as well as on how to best
          pursue a Ph.D. in this context.
        </p>
        <p>
          Current Ph.D. students at any stage of their career are encouraged to
          submit a 3-page extended abstract about their research to be
          considered for the Ph.D. Forum. The student should be the sole author,
          although the contributions of the advisor and others should be
          acknowledged. Submissions will be reviewed by the Ph.D. Forum program
          committee to ensure quality, relevance, and potential benefit from
          attendance at the Forum. Submissions are expected to include
          motivation of the importance and challenges to the particular problem,
          and initial results that support either the importance of the research
          problem or viability of solutions. Authors of accepted submissions are
          expected to participate in-person. The proceedings of the Forum will
          be included in the proceedings of the main conference.
        </p>
        <h3>Submission Guidelines</h3>
        <p>
          Abstract should be no more than 3 pages in length, including figures,
          tables, and references.
        </p>
        <p>
          A brief statement by the Ph.D. advisor in support of the submission as
          well as a CV of the PhD candidate (max. 3 pages) should be submitted
          together with the abstract.
        </p>
        <p>
          Authors are requested to submit manuscripts in standard IEEE
          proceedings format in PDF. All submissions must be typeset in
          double-column IEEE format using 10pt fonts on US letter paper, with
          all fonts embedded. Submitted abstracts must include the contact
          information of the authors. Please make sure you use the latest
          version of the templates to prepare your submissions.
        </p>
        <SubmissionButton props={submitButton} className="submit-button" />

        <h3>Important Dates</h3>
        <p>
          Submission: <span style={{ fontWeight: "bold" }}>20 April 2025</span>
        </p>
        <p>
          Acceptance notification:{" "}
          <span style={{ fontWeight: "bold" }}>01 May 2025</span>
        </p>
        <p>
          Camera ready: <span style={{ fontWeight: "bold" }}>10 May 2025</span>
        </p>
        <h3>SMARTCOMP 2025 PhD Forum Chairs</h3>
        <div>
          {profilesPhD.map(function (data) {
            return <Profile props={data} />;
          })}
        </div>
      </div>
    </div>
  );
};
